import React, { useState } from "react";
import { Transition } from "react-transition-group";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import UIfx from "uifx";

import succes from "../../../../assets/succes.wav";
import fail from "../../../../assets/fail.mp3";

import { useHint } from "../../context/useHintContext";
import { useHintContainer } from "../../context/useHintContainerContext";
import { useOvertime } from "../../context/useOvertimeContext";
import {
  Title,
  IntroText,
  SolutionInput,
  SubmitButton,
  ErrorText,
  SuccessText,
} from "./styled";
import { getIntroText, checkSolution, nmbrOfChars } from "./helpers/index";

const Round = ({ game, round, roundCounter, deductTimeAnimation, getTime }) => {
  const { step, handleRoundStep } = useHint();
  const { setPlay } = useOvertime();
  const { register, handleSubmit, errors, reset } = useForm();
  const [wrongSolution, wrongSolutionHandler] = useState(false);
  const [rightSolution, rightSolutionHandler] = useState(false);
  const [chars, setNmbrOfChars] = useState(["", "", ""]);
  const { clearHints } = useHintContainer();

  const { newStep } = useHint();

  const succesSound = new UIfx(succes, {
    volume: 0.5, // number between 0.0 ~ 1.0
    throttleMs: 100,
  });

  const failSound = new UIfx(fail, {
    volume: 0.5, // number between 0.0 ~ 1.0
    throttleMs: 100,
  });

  React.useEffect(() => {
    reset();
    setPlay(true);
    wrongSolutionHandler(false);
    rightSolutionHandler(false);
    const nmbr = nmbrOfChars(`round${round}`, game, round);

    if (nmbr) {
      const nmbrRes = nmbr.split("");
      setNmbrOfChars(nmbrRes);
    }

    const returnToTop = () => {
      document.body.scrollTop = 0; //Safari
      document.documentElement.scrollTop = 0; // Chrome, Firefox, IE and Opera
    };
    returnToTop();
  }, [reset, round]);

  const nextRound = () => {
    let currentTime;

    if (round < 5) {
      const time = getTime();
      currentTime = Math.floor(time);

      const newStep = round + 1;
      roundCounter(round + 1);
      // voeg hier de tijd toe aan handleRoundStep.
      // probeer hier toegang te krijgen tot de tijd in milliseconde
      handleRoundStep(newStep, currentTime);
      clearHints();
    } else {
      const newStep = round + 1;
      roundCounter(round + 1);
      // voeg hier de tijd toe aan handleRoundStep.
      // probeer hier toegang te krijgen tot de tijd in milliseconde
      handleRoundStep(newStep, currentTime);
      clearHints();
    }
  };

  const allRounds = game.playerGame.rounds;

  const onSubmit = (data) => {
    const answerArr = [];
    Object.values(data).forEach((value) => {
      answerArr.push(value);
    });

    let answer = answerArr.join("").toLowerCase();
    const solutionCheck = checkSolution(`round${round}`, answer, allRounds);

    if (solutionCheck === true) {
      succesSound.play();
      rightSolutionHandler(true);
    } else {
      wrongSolutionHandler(true);
      failSound.play();
      deductTimeAnimation();
      setTimeout(() => {
        reset();
        wrongSolutionHandler(false);
      }, 5000);
    }
  };

  const autoFocus = (e) => {
    const target = e.srcElement || e.target;
    const maxLength = parseInt(target.attributes["maxlength"].value, 10);

    const myLength = target.value.length;
    if (myLength >= maxLength) {
      // dit moet een var zijn anders kan hij niet worden ge-reassigned
      var next = target;
      while ((next = next.nextElementSibling)) {
        if (next == null) break;
        if (next.tagName.toLowerCase() === "input") {
          next.focus();
          break;
        }
      }
    } else if (myLength === 0) {
      // dit moet een var zijn anders kan hij niet worden ge-reassigned
      var previous = target;
      while ((previous = previous.previousElementSibling)) {
        if (previous == null) break;
        if (previous.tagName.toLowerCase() === "input") {
          previous.focus();
          break;
        }
      }
    }
  };
  return (
    <Transition timeout={4000} in={true} appear>
      {(status) => (
        <div className={`box box-${status}`}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ErrorText wrongSolution={wrongSolution}>
              Jammer, de code is niet goed. Dat betekent één strafminuut!
              Probeer het nog eens.
            </ErrorText>
            <SuccessText rightSolution={rightSolution}>
              De ingevulde code is juist!
            </SuccessText>
            {/* culprit */}
            {chars ? (
              chars.map((char, index) => (
                <SolutionInput
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  onChange={autoFocus}
                  wrongSolution={wrongSolution}
                  rightSolution={rightSolution}
                  className="container"
                  style={{ textTransform: "lowercase" }}
                  type="text"
                  name={`answer` + index}
                  maxLength="1"
                  ref={register({
                    required: true,
                    max: 1,
                    min: 1,
                    message: "Invullen van een cijfer is verplicht",
                    maxLength: 1,
                  })}
                />
              ))
            ) : (
              <>
                <SolutionInput
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  wrongSolution={wrongSolution}
                  style="text-transform: lower-case"
                  rightSolution={rightSolution}
                  className="container"
                  style={{ textTransform: "lowercase" }}
                  type="text"
                  name="answerTwo"
                  maxLength="1"
                  ref={register({
                    required: true,
                    max: 1,
                    min: 1,
                    message: "Invullen van een cijfer is verplicht",
                    maxLength: 1,
                  })}
                />
                <SolutionInput
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  wrongSolution={wrongSolution}
                  rightSolution={rightSolution}
                  className="container"
                  type="text"
                  name="answerTwo"
                  style={{ textTransform: "lowercase" }}
                  maxLength="1"
                  ref={register({
                    required: true,
                    max: 1,
                    min: 1,
                    message: "Invullen van een cijfer is verplicht",
                    maxLength: 1,
                  })}
                />
                <SolutionInput
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  wrongSolution={wrongSolution}
                  rightSolution={rightSolution}
                  className="container"
                  type="text"
                  name="answerTwo"
                  style={{ textTransform: "lowercase" }}
                  maxLength="1"
                  ref={register({
                    required: true,
                    max: 1,
                    min: 1,
                    message: "Invullen van een cijfer is verplicht",
                    maxLength: 1,
                  })}
                />
              </>
            )}
            {rightSolution ? (
              <>
                <br />
                <SubmitButton onClick={nextRound}>
                  {round < 4 ? "Volgende ronde" : "Stop de tijd!"}
                </SubmitButton>
              </>
            ) : (
              <>
                <br />
                <SubmitButton type="submit">antwoord controleren</SubmitButton>
              </>
            )}
          </form>
        </div>
      )}
    </Transition>
  );
};

const RoundText = ({ game, round }) => {
  const allRounds = game.playerGame.rounds;

  return (
    <Transition timeout={4000} in={true} appear>
      {(status) => (
        <div className={`box box-${status}`}>
          <Title>Ronde {round}</Title>
          <IntroText>{getIntroText(`round${round}`, allRounds)}</IntroText>
        </div>
      )}
    </Transition>
  );
};

export { RoundText, Round };
